module.exports = __webpack_public_path__ + "img/f2.cfbac9ee.png";